import React,{ useEffect, useState } from 'react'
import moment from 'moment';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import ApiService from '@services/api.service';
import { toast } from 'react-toastify';
import { Col, Row } from 'antd';
import dayjs from 'dayjs';
import { Select } from 'antd';
import { Button } from 'antd';
import { DatePicker } from 'antd';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { Spin } from 'antd';

interface DataType {
      key: React.Key;
      name: string;
      age: number;
      address: string;
  }
  
 
 
  const columns: ColumnsType<DataType> = [
      {
          title: 'Practice Name',
          dataIndex: 'practiceName',
          key: 'practiceName',
        //   sorter: true, 
          sorter: (a:any, b:any) => a.practiceName.localeCompare(b.practiceName),
      },
      {
          title: 'Status',
          dataIndex: 'status',
          key: 'Status',
          sorter: (a:any, b:any) => a.status.localeCompare(b.status),

      },
      {
          title: 'Join Date',
          dataIndex: 'createdAt',
          key:'createdAt',
          sorter: (a:any, b:any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),

      },
      {
          title: 'Join Rate',
          key: 'joinRate',
          dataIndex: 'joinRate',
          sorter: (a:any, b:any) => Number(a.joinRate.substring(1)) - Number(b.joinRate.substring(1)),
      },
      {
          title: 'Cancel Date',
          key: 'cancelDate',
          dataIndex: 'cancelDate',
          sorter: (a:any, b:any) => new Date(a.cancelDate).getTime() - new Date(b.cancelDate).getTime(),
      },
      {
          title: 'Rate Adjustments (Prorated)',
          key: 'proratedSum',
          dataIndex: 'proratedSum',
          sorter: (a:any, b:any) => Number(a.proratedSum.substring(1)) - Number(b.proratedSum.substring(1)),
      },
      {
          title: 'Total Billed for this Range',
          key: 'totalThisMonth',
          dataIndex: 'totalThisMonth',
          sorter: (a:any, b:any) => Number(a.totalThisMonth.substring(1)) - Number(b.totalThisMonth.substring(1)),
      }
  ];

const Reports = () => {
  
   const [excelData,setExcelData]:any = useState()
   const [tableData,setTableData]:any = useState()
   const [selectRange, setSelectRange] = useState(true);
   const [totalr,setTotalr] = useState(0)
   const [exportLoading, setIsExportLoading] = useState(false);
   const [tableLoading, setIsTableLoading] = useState(true);
   const [selectedDropdownValue,setSelectedDropdownValue]:any = useState()
   let today = dayjs();
   const lastMonth = today.subtract(1, 'month');
   const lastMonthStart = lastMonth.startOf('month');
   const lastMonthEnd = lastMonth.endOf('month');
   const [range, setRange]:any = useState([lastMonthStart,lastMonthEnd]);
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [selectedRange, setSelectedRange]:any = useState([lastMonthStart,lastMonthEnd]);
   const currentQuarter = dayjs().quarter();
   const previousQuarterDate = dayjs().quarter(currentQuarter - 1);
   const previousQuarterStart = previousQuarterDate.startOf('quarter');
   const previousQuarterEnd = previousQuarterDate.endOf('quarter');
   const { Option } = Select
   const { RangePicker } = DatePicker;
   let minDate = dayjs('2025-01-01');
   const disableInvalidDates = (current:any) => {
        return (
        !current ||
        current < minDate.startOf('day') ||
        current >= dayjs().startOf('day') // disables today and future
        );
    };


     const handleSelectChange = (value: string) => {
          setSelectedDropdownValue(value);
          let defaultEnd:any;
          let defaultStart = dayjs().subtract(Number(value), 'day');         
          if(value==='0'){
              defaultEnd = dayjs();
          }
          else{
              defaultEnd = dayjs().subtract(1, 'day');;
          }
          if(value==='Custom'){
              // eslint-disable-next-line no-sparse-arrays
              setRange([,])
          }else if(value==='lastq'){
              setRange([previousQuarterStart,previousQuarterEnd])
          }else if(value==='lastm'){
              setRange([lastMonthStart,lastMonthEnd])
          }
          else{
              setRange([defaultStart,defaultEnd])
          }         
      };

    useEffect(()=>{
        // window.alert(range.length)
        if(range.length>0 && selectedDropdownValue!=='Custom'){
            exportToExcel('table')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[range])

   const exportToExcel = async (action:string) => {
           if(range.length===0){
               setSelectRange(false)
           }
           if(range.length > 0){
               setSelectRange(true)
               console.log('range[0].format("YYYY-MM-DD")',range[0].format("YYYY-MM-DD"))
               console.log('range[0].format("YYYY-MM-DD")',range[1].format("YYYY-MM-DD"))
               if(action==='table'){
                 setIsTableLoading(true)
               }else{
                 setIsExportLoading(true)
               }
               ApiService.getExcelData([range[0].format("YYYY-MM-DD"),range[1].format("YYYY-MM-DD"),],'monthly').then(({data}:any)=>{
                   setIsExportLoading(false)
                   setIsTableLoading(false)
                   setSelectedRange(range)
                   let excelData = data?.data?.medicalPractice?.map((practice:any)=>{
                       return {
                           id:practice.id,
                           subscriptionId:practice.subscriptionId,
                           practiceName:practice.practiceName,
                           status:practice.status==='Active' ? 'Active' : 'Cancelled',
                           originalSubscription:`$`+practice.firstPayment,
                           previousMonthBill:`$`+practice.lastPayment,
                           newCharges:practice?.subscriptions  && `$`+(practice?.subscriptions[0]?.amount-practice?.lastPayment),
                           currentBill:practice?.subscriptions && `$`+practice?.subscriptions[0]?.amount,
                           createdAt:moment.utc(practice.createdAt).format('DD MMM, YYYY'),
                           customerId:'Alchemy'+practice?.id,
                           joinRate:`$`+practice?.joinRate.toFixed(2),
                           totalThisMonth:`$`+practice?.totalThisMonth.toFixed(2),
                           cancelDate:practice?.findCancelPayment?.length >= 1 ? moment(practice?.findCancelPayment[0]?.captureDate).format('DD MMM, YYYY') : '-',
                           proratedSum:`$`+practice?.proratedsum.toFixed(2)
                       }
                   })
               console.log('practice',excelData)
               if(excelData?.length===0){
                   toast.error('No transaction found during this dates')
               }
                let totalRev=0;
                excelData?.forEach((data:any)=>{
                    console.log(Number(totalRev) + Number(data?.totalThisMonth?.slice(1)))
                    console.log(data)
                    totalRev = Number(totalRev) + Number(data?.totalThisMonth?.slice(1));
                })
                setTotalr(totalRev)
                if(action==='table'){
                  setTableData(excelData)
                }else{
                  setExcelData(excelData)
                }
               }).catch((error)=>{
               toast.error(error.message)
               })
               }
         };
          useEffect(()=>{
                     async function generateExcel(){
                         const workbook = new ExcelJS.Workbook();
                         const worksheet = workbook.addWorksheet('My Sheet');
                         worksheet.columns = [
                         { header: 'Name', key: 'name', width: 35 },
                         { header: 'Age', key: 'age', width:20 },
                         { header: 'Email', key: 'email', width:10},
                         { header: '1', key: '1', width:10 },
                         { header: '2', key: '2', width:10 },
                         { header: '2', key: '2', width:10 },
                        //  { header: '2', key: '2', width:10 },
                        //  { header: '2', key: '2', width:10 },
                         ];
                         let totalRev=0;
                         excelData?.forEach((data:any)=>{
                             console.log(Number(totalRev) + Number(data?.totalThisMonth?.slice(1)))
                             totalRev = Number(totalRev) + Number(data?.totalThisMonth?.slice(1));
                         })
                         worksheet.mergeCells('A1:B1');
                         worksheet.mergeCells('A2:B2');
         
                         const mergedHeader = worksheet.getCell('A1');
                         mergedHeader.value = 'FINANCIAL REPORT FROM– '+range[0].format('DD MMM, YYYY')+' to '+range[1].format('DD MMM, YYYY');
         
                         const mergedHeader6 = worksheet.getCell('A2');
                         mergedHeader6.value = '';
         
                         worksheet.mergeCells('C1:D1');
                         worksheet.mergeCells('C2:D2');
         
                         const mergedHeader1 = worksheet.getCell('C1');
                         mergedHeader1.value = 'Total Gross Revenue';
         
                         const mergedHeader7 = worksheet.getCell('C2');
                         mergedHeader7.value = '$'+totalRev.toFixed(2);
         
                         worksheet.mergeCells('E1:F1');
                         worksheet.mergeCells('E2:F2');
         
                         const mergedHeader2 = worksheet.getCell('E1');
                         mergedHeader2.value = '20% Academy Rev Share';
         
                         const mergedHeader8 = worksheet.getCell('E2');
                         mergedHeader8.value = '$'+((totalRev*20)/100).toFixed(2);
         
                        //  worksheet.mergeCells('G1:H1');
                        //  worksheet.mergeCells('G2:H2');
         
                        //  const mergedHeader3 = worksheet.getCell('G1');
                        //  mergedHeader3.value = 'Rev Retained by Alchemy';
         
                        //  const mergedHeader9 = worksheet.getCell('G2');
                        //  mergedHeader9.value = '$'+(totalRev*80/100).toFixed(2);
         
                         const headerRow = worksheet.getRow(1);
                         headerRow.font = { bold: true, size: 13, name:'Helvetica' };
         
                         // Add a normal row with font styling
                         const row = worksheet.getRow(2);
                         row.height = 40; 
                         row.alignment = {
                             vertical: 'middle', // Aligns text vertically (top, middle, bottom)
                         };
                         row.eachCell(cell => {
                             cell.font = { size: 14,name:'Helvetica' };
                         });
         
                     
                         worksheet.addRow(['', '','','','']);
                         worksheet.addRow(['Practice Name', 'Customer ID','Status','Join Date','Join Rate','Cancel Date','Rate Adjustments','Total Billed for this Range']);
                         const row4 = worksheet.getRow(4);
                         row4.eachCell(cell => {
                             cell.font = { size: 14,name:'Helvetica' };
                         });
         
                         worksheet.columns.forEach((column, index) => {
                             if (index === 0) return;
                             let maxLength = column.header?.length || 10;
                             
                             column.eachCell?.({ includeEmpty: true }, cell => {
                             const text = cell.value ? cell.value.toString() : '';
                             if (text.length > maxLength) maxLength = text.length;
                             });
         
                             column.width = maxLength; // Add padding
                         });
                         // eslint-disable-next-line array-callback-return
                         excelData?.map((data:any)=>{
                             console.log('data?.proratedsum',data?.proratedSum)
                             worksheet.addRow([data?.practiceName,data?.customerId,data?.status,data?.createdAt,data?.joinRate,data?.cancelDate,Number(data?.proratedSum.substring(1)) > 0 ? data?.proratedSum : '-',data?.totalThisMonth]);
                         })
                         // Exportlength
                         const buffer = await workbook.xlsx.writeBuffer();
                         const blob = new Blob([buffer], { type: 'application/octet-stream' });
                         saveAs(blob, range[0].format("DD/MM/YYYY")+'-'+range[1].format("DD/MM/YYYY")+'.xlsx');
                         setExcelData()
                     }
                    
                     if(excelData?.length>1){
                         generateExcel()
                     }
                     // eslint-disable-next-line react-hooks/exhaustive-deps
                     },[excelData])

  return (
    <>
      <div>
          <div style={{paddingTop:10,paddingBottom:10}}>
                <div style={{background:'white',minHeight:'208px',alignContent:'center'}}>
                    {
                     tableLoading===false ?
                    
                    <Row style={{padding:"20px 30px"}}>
                        {range?.length > 0 &&
                        <Col md={24}>
                        <h4>Selected Range {range[0]?.format("YYYY-MM-DD") + ` to ` + range[1]?.format("YYYY-MM-DD")}</h4>
                        </Col>
                        }
                        <Col md={12} style={{textAlign:'center'}}>
                            <h3>Total Gross Revenue</h3>
                            <h1>{totalr > 0 ? '$'+totalr.toFixed(2) : '-'}</h1>
                        </Col>
                        <Col md={12} style={{textAlign:'center'}}>
                            <h3>20% Academy Rev Share</h3>
                            <h1>{totalr > 0 ?  '$'+((totalr*20)/100).toFixed(2):'-'}</h1>
                        </Col>
                        {/* <Col md={8} style={{textAlign:'center'}}>
                            <h3>Rev Retained by Alchemy</h3>
                            <h1>{totalr > 0 ?'$'+((totalr*80)/100).toFixed(2) : '-'}</h1>
                        </Col> */}
                    </Row>
                    :
                    <div style={{padding:"20px 30px",textAlign:'center'}}>
                    <Spin />
                    </div>
                    }
                </div>
                <Row style={{marginTop:20}}>
                    <Col md={8} sm={8}></Col>
                    <Col md={16} sm={16} style={{textAlign:'right'}}>
                        <Select
                        showSearch={false}
                        value={selectedDropdownValue}
                        placeholder="Select date range"
                        style={{ width: "200px"}}  
                        defaultValue={'lastm'}
                        onChange={handleSelectChange}
                        >&nbsp;&nbsp;
                            <Option key={`1`} value={'lastm'}>Last Month</Option>
                            <Option key={`2`} value={'lastq'}>Last Quarter</Option>
                            <Option key={`3`} value={'Custom'}>Custom</Option>
                        </Select>&nbsp;&nbsp;
                        <RangePicker   disabledDate={disableInvalidDates}  value={range} onChange={(dates) => {setRange(dates); setSelectRange(true); setSelectedDropdownValue('Custom')}} />&nbsp;&nbsp;
                        <Button type="primary" className='btn' loading={tableLoading} onClick={()=>{exportToExcel('table')}}> Search </Button>&nbsp;&nbsp;
                        <Button type="primary" className='btn' loading={exportLoading} onClick={()=>{exportToExcel('excel')}}> Export excel </Button><br/>
                        <div style={{textAlign:'left'}}>
                        {selectRange===false && <span style={{color:'red'}}>Please Select Date Range</span>}
                        </div>
                    </Col>
                </Row>
            </div>
        <Table
          bordered
          columns={columns} 
          loading={tableLoading}
          scroll={{ y: 'calc(100vh - 215px)', x: 100 }}
          dataSource={tableData}
          // onChange={handleTableChange}
      />
      </div>
    </>
  )
}

export default Reports